// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"425":"4bf71666","519":"5d4b9375","558":"1105279d","661":"c59063fa","864":"087781d3"}[chunkId] + ".chunk.css";
};